import styled from "styled-components/macro";
export const Hyperlinked = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
`;
